import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowTitle = _resolveComponent("WindowTitle")!
  const _component_Flights = _resolveComponent("Flights")!
  const _component_WindowContent = _resolveComponent("WindowContent")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createBlock(_component_Window, { class: "dashboard-arrivals" }, {
    default: _withCtx(() => [
      _createVNode(_component_WindowTitle, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Shuttle Arrivals ")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_WindowContent, null, {
        default: _withCtx(() => [
          _createVNode(_component_Flights, {
            flights: _ctx.flights,
            arrivals: true
          }, null, 8, ["flights"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}